// ============================================================
// ENTRY — mounts <App/> into #root. Tailwind + global CSS come in via
// ./index.css (which @tailwind-imports + the ported mock <style> block).
// ============================================================
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    {/* 最上位の ErrorBoundary：App（ルーティング・認証）ごと落ちた場合の最終防衛線。 */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
